"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricDefinitionsDisplayGrid = exports.getRowDataForMetricDefinition = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
const ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
function getRowDataForMetricDefinition(metricDefinition) {
    return {
        id: metricDefinition.id,
        luid: metricDefinition.luid,
        name: metricDefinition.name,
        metricsCount: null,
        followersCount: null,
    };
}
exports.getRowDataForMetricDefinition = getRowDataForMetricDefinition;
const shouldBeObfuscated = ({ name }) => name === null;
function columns() {
    const cols = [
        (sortParams) => ({
            name: 'name',
            dataKey: catalog_queries_1.MetricDefinitionOrderField.NAME,
            headerText: catalog_messages_1.Messages.GridHeaderMetricDefinitions(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter)(shouldBeObfuscated, ({ name }) => name, (urls, { luid }) => urls.pulseMetricDefinitionPath(luid), false, false, true),
            growToFit: true,
            resizable: true,
            sortable: true,
        }),
        (sortParams) => ({
            name: 'metricsCount',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderTotalMetrics(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ metricsCount }) => metricsCount !== null && metricsCount !== void 0 ? metricsCount : 0),
            resizable: true,
            sortable: false,
        }),
        (sortParams) => ({
            name: 'followersCount',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderTotalFollowers(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ followersCount }) => followersCount !== null && followersCount !== void 0 ? followersCount : 0),
            resizable: true,
            sortable: false,
        }),
    ];
    return cols.filter(Boolean);
}
function MetricDefinitionsDisplayGrid(props) {
    const cols = columns().map((columnFactory) => columnFactory(props));
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.MetricDefinitionsDisplayGrid = MetricDefinitionsDisplayGrid;
//# sourceMappingURL=MetricDefinitionsDisplayGrid.js.map